// extracted by mini-css-extract-plugin
export var backupIcon = "_p5-1";
export var image = "_p5-0";